<template>
  <form class="space-y-24" method="POST">
    <Payment :policy-id :total-price />
  </form>
</template>

<script setup lang="ts">
import type { MonetaryAmount } from '@backmarket/http-api'

import Payment from '../Payment/Payment.vue'

defineProps<{
  policyId: string
  totalPrice: MonetaryAmount
}>()
</script>
